import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import loadable from '@loadable/component';
import Loading from '../components/common/Loading';
import Layout from '../containers/layout/Main';
import LayoutLogin from '../containers/layout/Login';
import PrivateRoute from './PrivateRoute';

const PowerRimac = loadable(() => import('../containers/view/Actividades'), {
  fallback: <Loading />
});

const CreacionQuick = loadable(() => import('../containers/view/AccionQuick/creacionQuick'), {
  fallback: <Loading />
});

const ListadoQuick = loadable(() => import('../containers/view/AccionQuick/listarQuick'), {
  fallback: <Loading />
});

const CreacionDeep = loadable(() => import('../containers/view/AccionDeep/creacionDeep'), {
  fallback: <Loading />
});

const ListadoDeep = loadable(() => import('../containers/view/AccionDeep/listarDeep'), {
  fallback: <Loading />
});

const DetalleDeep = loadable(() => import('../containers/view/AccionDeep/detalleDeep'), {
  fallback: <Loading />
});

const CierreDeep = loadable(() => import('../containers/view/AccionDeep/CierreDeep'), {
  fallback: <Loading />
});

const Login = loadable(() => import('../containers/view/Login'), {
  fallback: <Loading />
});

const LoginExterno = loadable(
  () => import('../containers/view/Login/LoginExterno'), {
    fallback: <Loading />
});

const ChangePassword = loadable(
  () => import('../containers/view/ChangePassword'), {
    fallback: <Loading />
});

const NotFound = loadable(() => import('../containers/view/NotFound'), {
  fallback: <Loading />
});

const CerrarSesion = loadable(() => import('../containers/view/Reset'), {
    fallback: <Loading/>
})

const RouterMain = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={() => <Redirect to="/seguimiento" />} />
        <Route path="/sign-out" exact component={CerrarSesion} />
        <Route path="/404" exact>
          <Layout>
            <Route path="/404" exact component={NotFound} />
          </Layout>
        </Route>
        <Route path="/(login|change-password|login-externo)" exact>
          <LayoutLogin>
            <Switch>
              <Route path="/login" exact component={Login} />
              <Route path="/login-externo" exact component={LoginExterno} />
              <Route path="/change-password" exact component={ChangePassword} />
            </Switch>
          </LayoutLogin>
        </Route>
        <Route>
          <PrivateRoute>
            <Layout>
              <Switch>
                <Route path="/seguimiento" exact component={PowerRimac} />
                <Route path="/seguimiento/creacion/deep" component={CreacionDeep} />
                <Route path="/seguimiento/listado/deep" component={ListadoDeep} />
                <Route path="/seguimiento/detalle/deep" exact component={DetalleDeep} />
                <Route path="/seguimiento/cierre/deep" exact component={CierreDeep} />
                <Route path="/seguimiento/creacion/quick" component={CreacionQuick} />
                <Route path="/seguimiento/listado/quick" component={ListadoQuick} />
                <Route component={() => <Redirect to="/404" />} />
              </Switch>
            </Layout>
          </PrivateRoute>
        </Route>
      </Switch>
    </Router>
  );
};

export default RouterMain;
